export default "__VITE_ASSET__DuCRn85A__"